import React from 'react';
import { useNavigate } from 'react-router-dom';
import authStore from '../../stores/authStore';

export default function SignupForm(activeTab, setActiveTab) {

    const store = authStore();
    const navigate = useNavigate(); // this is a react hook

    const handleSignup = async (e) => {
        e.preventDefault();
      
        let res = await store.signup();
        
        if (res === "OK") {
           
            navigate("/");
        } else {
            
        }

    };

    return (
        <div className="loginForm">
            <form onSubmit={handleSignup}>
                <label>Username</label>
                <input onChange={store.updateSignupForm} value={store.signupForm.username} name="username"/>
                <label>Email address</label>
                <input onChange={store.updateSignupForm} value={store.signupForm.email} type="email" name="email"/>
                <label>Password</label>
                <input onChange={store.updateSignupForm} value={store.signupForm.password} type="password" name="password"/>
                <p className="termsMessage">By signing up you agree to the  
                    <a href="https://scopedtv.com/privacy-notice" target="_blank"> Privacy Policy</a>.</p>
                <div className="formButtonCenter"><button type="submit">Agree and continue</button></div>
            </form>
        </div>
    )
}